export const openVk = () => window?.open('https://vk.com/profutru', '_blank');

